import React, {Component} from 'react';
import styles from '../css/LeftMenu.module.css';

class LeftMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            active: props.active
        };
    }

    render() {
        return (
            <div className={styles.LeftMenu}>
                <div></div>
                <div  className={this.props.active === 0 ? styles.active : ""}  onClick={() => {
                        this.props.changeView(0)
                    }}>User Management</div>
                <div className={this.props.active === 1 ? styles.active : ""} onClick={() => {
                        this.props.changeView(1)
                    }}>Targeting Exercises</div>
                <div className={this.props.active === 2 ? styles.active : ""} onClick={() => {
                    this.props.changeView(2)
                }} styles="cursor:pointer;">System Audit</div>
            </div>
        );
    }
}

export default LeftMenu;
